import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { Unit } from '../../../../app/models/Unit';

type Props = {
    unitDataForm: Unit;
    setUnitDataForm: (unit: Unit) => void;
    errorFields?: any;
};

const UnitForm = ({ unitDataForm, setUnitDataForm, errorFields }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setUnitDataForm({ ...unitDataForm, [name]: value });
    };

    return (
        <>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Nombre</label>
                <div className="col-md-9">
                    <input
                        name="name"
                        id="name"
                        type="text"
                        className={`form-control ${fieldHasError('name')}`}
                        value={unitDataForm.name}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('name')}
                        placeholder="Ingrese el nombre de unidad"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('name')}
                    </div>
                </div>
            </div>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Símbolo</label>
                <div className="col-md-9">
                    <input
                        name="symbol"
                        id="symbol"
                        type="text"
                        className={`form-control ${fieldHasError('symbol')}`}
                        value={unitDataForm.symbol || ''}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('symbol')}
                        placeholder="Ingrese el símbolo (ej: kg, m, l)"
                        maxLength={10}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('symbol')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default UnitForm;
